import { render } from "./adjuntos.vue?vue&type=template&id=db96b53c"
import script from "./adjuntos.vue?vue&type=script&lang=js"
export * from "./adjuntos.vue?vue&type=script&lang=js"

import "./adjuntos.vue?vue&type=style&index=0&id=db96b53c&lang=css"

import exportComponent from "/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__